module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/age-check-38d9f79dc8571b92.png"+" 384w",
        images: [{path: __webpack_public_path__ + "assets/images/age-check-38d9f79dc8571b92.png",width: 384,height: 510}],
        src: __webpack_public_path__ + "assets/images/age-check-38d9f79dc8571b92.png",
        toString: function(){return __webpack_public_path__ + "assets/images/age-check-38d9f79dc8571b92.png"},
        
        width: 384,
        height: 510
      }